<script>
    import { t } from '$lib/i18n.js';
</script>

<section>
    <div class="max-width">
        <div class="col">
            <img src="https://assets.auting.it/images/draws/home-pricing.svg" alt="" />
            <h2>{$t('routes.home.pricing.subtitle')}</h2>
            <h2 class="accent">{$t('routes.home.pricing.title_accent')}</h2>
            <h3 class="">{$t('routes.home.pricing.description')}</h3>
        </div>
        <div class="col box auting">
            <img src="https://assets.auting.it/images/logo/logo.svg" alt="Auting Logo" />
            <p>{$t('routes.home.pricing.cols.auting.description')}</p>
            <ul>
                <li><p>{$t('routes.home.pricing.cols.auting.items.1')}</p></li>
                <li><p>{$t('routes.home.pricing.cols.auting.items.2')}</p></li>
                <li><p>{$t('routes.home.pricing.cols.auting.items.3')}</p></li>
                <li><p>{$t('routes.home.pricing.cols.auting.items.4')}</p></li>
            </ul>
            <div>
                <p class="label">{$t('routes.home.pricing.cols.auting.alt.sub_description')}</p>
                <ul>
                    <li><p>{$t('routes.home.pricing.cols.auting.alt.sub_items.1')}</p></li>
                </ul>
            </div>
        </div>
        <div class="col box">
            <h3>{$t('routes.home.pricing.cols.other.title')}</h3>
            <p class="label">{$t('routes.home.pricing.cols.other.description')}</p>
            <ul>
                <li><p>{$t('routes.home.pricing.cols.other.items.1')}</p></li>
                <li><p>{$t('routes.home.pricing.cols.other.items.2')}</p></li>
                <li><p>{$t('routes.home.pricing.cols.other.items.3')}</p></li>
                <li><p>{$t('routes.home.pricing.cols.other.items.4')}</p></li>
            </ul>
            <div>
                <p class="label">{$t('routes.home.pricing.cols.other.alt.sub_separator')}</p>
                <p>{$t('routes.home.pricing.cols.other.alt.sub_description')}</p>
                <ul>
                    <li><p>{$t('routes.home.pricing.cols.other.alt.sub_items.1')}</p></li>
                    <li><p>{$t('routes.home.pricing.cols.other.alt.sub_items.2')}</p></li>
                    <li><p>{$t('routes.home.pricing.cols.other.alt.sub_items.3')}</p></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<style>
    section {
        padding: 1rem 2rem;
        padding-top: 100px;
    }

	section, .max-width {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 16px;
    }

    .max-width {
        max-width: var(--max-width);
        width: 100%;
        
    }

    .col {
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: flex-start;
        gap: 8px;
        flex: 2;
    }

    .col img {
        max-width: 300px;
        margin-bottom: 16px;
    }

    .col.box {
        padding: 16px;
        border-radius: 24px;
        background-color: var(--surface);
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.16);
        height: 500px;
        flex: 1;
        align-items: center;
    }

    .col.box.auting {
        border: 2px solid var(--orange);
    }

    .col.box.auting img {
        height: 32px;
        margin: 0;
        margin-top: 16px;
        margin-bottom: 16px;
    }

    h2 {
        font-size: 28px;
        letter-spacing: -1px;
        font-family: var(--font-body);
        text-align: left;
    }

    h2.accent {
        color: var(--orange);
        font-family: var(--font-heading);
        font-size: 48px;
        text-align: left;
    }

    h3 {
        font-family: var(--font-body);
        font-size: 24px;
        text-align: left;
        margin: 0;
        margin-top: 16px;
        margin-bottom: 16px;
    }

    h3.accent {
        color: var(--orange);
    }

    p.label {
        color: var(--on-surface-50);
    }
    
    p {
        color: var(--on-surface);
    }
    
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    li {
        padding: 0px;
        margin: 0px;
    }

    li p {
        color: var(--on-surface);
        font-weight: 500;
        margin: 0;
    }

    @media (max-width: 768px) {
        section, .max-width {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 1rem;
        }

        section {
            padding-top: 120px;
            padding-bottom: 20px;
        }
        
        .max-width {
           padding: 0;
        }

        li p {
            font-size: 20px;
        }

        .col.box {
            padding: 24px;
            border-radius: 24px;
            background-color: var(--surface);
            box-shadow: 0 2px 16px rgba(0, 0, 0, 0.16);
            height: auto;
            flex: 1;
            align-items: flex-start;
            width: 100%;
        }

        p, li p {
            font-size: 16px;
        }
    }
</style>